import type { ComponentProps } from 'react'
import { Badge } from '../../../../components/ui'

type BadgeColor = ComponentProps<typeof Badge>['variant']

export const PARTNER_COLORS: Record<string, BadgeColor> = {
  'Function Health': 'indigo',
  'Quest Diagnostics': 'sky',
  Labcorp: 'emerald',
}
